import { Link } from "gatsby";
import React from "react";
import { Rss } from "lucide-react";

import Navigation from "./navigation";
import Search from "./search/index";
import { ThemeSwitcher } from "./theme-switcher";
import Logo from "./ui/logo";

const Navbar = () => {
  return (
    <>
      <Link
        to="/"
        aria-label="Main page"
        className="group flex items-center gap-2 text-lg font-semibold md:text-base"
      >
        <Logo />
      </Link>
      <Navigation />
      <div className="flex w-full items-center justify-end gap-6 md:ml-auto md:max-w-40 md:gap-2 lg:gap-4 xl:max-w-60 xl:gap-10">
        <Search />
        <div className="flex items-center gap-3">
          <ThemeSwitcher />
          <a href="https://jsdev.space/rss.xml" aria-label="RSS"
            className="group cursor-pointer">
            <Rss
              size={ 20 }
              strokeWidth={ 1}
              className="transition-all duration-300 hover:scale-125 hover:fill-blueLight hover:stroke-blueLight"
            />
          </a>
        </div>
      </div>
    </>
  );
};
export default Navbar;
